<div class="container-fluid d-flex align-items-center h-100 justify-content-center gradient-bg">
   <div class="ml-3 mr-3 card rounded bg-lightgrey p-3 login-box">
      <div [@inbgOutAnimation] *ngIf="showSpinner" class="loading_overlay rounded" >
        <div class="loader-bg">
          <div class="loader"></div>
      </div>
      </div>
     <div class="row p-4">
       <img src="../../../assets/images/logo-clearramp-dark.png" class="pt-1 pb-1 pr-3 pl-3 w-100 center mx-auto">
     </div>
     <div class="row">
      <div *ngIf="errorMessage!=null" class="ml-3 mr-3 alert w-100 alert-danger">
        {{ errorMessage }}
     </div>
     <div *ngIf="sendMessage!=null" class="ml-3 mr-3 alert w-100 alert-success" role="alert">
        {{ sendMessage }}
     </div>
     <div *ngIf="showSuccess" class="ml-3 mr-3 alert w-100 alert-success" role="alert">
        Your password has been changed
      </div>
       <form class="mx-auto w-100 pl-4 pr-4">
         <p class="text-center">Request New Password</p>
          <div *ngIf="!showSuccess">
            <div *ngIf="!showStep2" class="form-group">
               <label class="mb-0 f-13 font-weight-light" for="inputUsername">Username</label>
               <input type="text" id="inputUsername" placeholder="Account Username Here" name="username" required autofocus class="form-control"
               [(ngModel)]="username" [ngModelOptions]="{standalone: true}">
           </div>
           <div *ngIf="showStep2" class="form-group">
              <label class="mb-0 f-13 font-weight-light" for="inputVerificationCode">Input verification code</label>
              <input type="text" id="inputVerificationCode" placeholder="Verification Code Here" name="verificationcode" required autofocus class="form-control"
              [(ngModel)]="verificationcode" [ngModelOptions]="{standalone: true}">
          </div>
          <div *ngIf="showStep2" class="form-group">
           <label class="mb-0 f-13 font-weight-light" for="inputPassword">New password</label>
           <input type="password" ng-minlength=8 id="inputPassword" placeholder="New Password Here" name="password" required autofocus class="form-control"
           [(ngModel)]="password" [ngModelOptions]="{standalone: true}">
           <small id="passwordHelpBlock" class="form-text text-muted text-center op-05">
            Your password must be at least 8 characters long.
          </small>
            </div>

           <div *ngIf="!showStep2" class="form-group">
               <button (click)="forgot()" type="button" id="getpw" class="btn button-animation w-100">
                   <span>Request new password</span>
               </button>
           </div>
           <div *ngIf="showStep2" class="form-group">
              <button (click)="confirmNewPassword()" type="button" id="submitpw" class="btn button-animation w-100">
                  <span>Submit new password</span>
              </button>
          </div>
             </div>
             <a [routerLink]="['/login']"><p class="font-weight-light opacity-reverse pb-1  text-center mb-2 cursor-pointer">Already have an account? Sign In</p></a>
             <a href="https://www.clearramp.com/pricing" style="padding:0px; border-radius: 0px;"><p class="font-weight-light opacity-reverse text-center cursor-pointer">Don't have an account? Sign Up</p></a>
             <p class="mt-2 h-50px text-muted text-center op-05 center"> © ClearRamp - Eagleox Technologies ApS {{ year }}</p>
       </form>
   </div>
 </div>
</div>
